/**
 * Created by fers on 26.09.15.
 */

import {declareEntity} from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
    entity: "announcementReads",
    graphQL: "AnnouncementRead",
    name: "Announcement Reads",
    storageType: 'schema',
    dynamoPrefix: 'sys',
    userEditable: false,
    defaultOrder: [['createdAt', 'DESC']],

    fields: (types) => { return {
        id: {
            name: "ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        user: {
            name: "User",
            to: () => types['users'],
            type: "relation",
        },
        read: {
            name: "Read",
            type: "boolean",
            defaultValue: false,
        },
        closed: {
            name: "Read",
            type: "boolean",
            defaultValue: false,
        },
        announcement: {
            name: "Announcement",
            to: () => types['announcements'],
            type: "relation",
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        author: {
            name: "Created By",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
